module.exports = __webpack_public_path__ + "static/media/pharma_innovation.f083fa0d.pdf";